import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const feedbackPlugin = createPlugin({
  id: 'feedback',
  routes: {
    root: rootRouteRef,
  },
});

export const FeedbackPage = feedbackPlugin.provide(
  createRoutableExtension({
    name: 'FeedbackPage',
    component: () =>
      import('./components/FeedbackForm').then(m => m.FeedbackForm),
    mountPoint: rootRouteRef,
  }),
);
